<template>
    <div class="inline-flex h-8 select-none items-center justify-center
        rounded border-2 border-green-500 bg-gray-900/75 font-mono backdrop-blur-sm">
        <slot></slot>
    </div>
</template>
